import { whatIfInnerSelector } from '../../WhatIfsSelector';

export const repeatEveryNYearsSelector = (state, props) =>
  whatIfInnerSelector(state, props).RepeatEveryNYears;

export const repeatForNYearsSelector = (state, props) =>
  whatIfInnerSelector(state, props).RepeatForNYears;

export const inflationSelector = (state, props) =>
  whatIfInnerSelector(state, props).Inflation * 100;
